const Noaccess = resolve =>require(['@/components/common/Noaccess.vue'], resolve)

export default {
	path: '/noaccess',
	component: Noaccess
}



// WEBPACK FOOTER //
// ./src/router/noaccess.js